import React, { useEffect } from "react"

import Button from "../../../../design-system/button"
import { classNames } from "../../../../utils/class-names"
import * as styles from "./index.module.scss"

interface BlogTableOfContentsLinkProps {
  activeItemId: string | null
  item: { id: string; text: string }
  setActiveItemId: (id: string | null) => void
}

const BlogTableOfContentsLink = ({
  activeItemId,
  item,
  setActiveItemId,
}: BlogTableOfContentsLinkProps) => {
  const isActive = item.id === activeItemId
  const linkId = `${item.id}-link`

  useEffect(() => {
    if (isActive) {
      document.getElementById(linkId)?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      })
    }
  }, [isActive, linkId])
  return (
    <Button
      href={`#${item.id}`}
      id={linkId}
      variant="unstyled"
      as="a"
      className={classNames(styles.link, isActive && styles.active)}
      onClick={() => setActiveItemId(item.id)}
    >
      {item.text}
    </Button>
  )
}

export default BlogTableOfContentsLink
